import(/* webpackMode: "eager" */ "/vercel/path0/apps/d2c-sales-tool/src/app/[lang]/[product]/[partner]/prepaid/(with-flex-template)/template.tsx");
